module.exports = __webpack_public_path__ + "img/role.ef78b5fc.png";